export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14955.b82ad978.jpg";